import axios from 'axios';

const fetchCart = () => axios.get('/v1/users/cart');
const updateCart = (data) => axios.put('v1/users/cart', data);

const CartAPI = { updateCart, fetchCart };

export default CartAPI;
